import Vue from 'vue'
import wysiwyg from 'vue-wysiwyg'

Vue.use(wysiwyg, {
  hideModules: {
    bolde: false,
    italic: false,
    underline: false,
    justifyLeft: false,
    justifyCenter: false,
    justifyRight: false,
    link: true,
    image: true,
    table: true,
    code: true,
    heading: false,
    orderedList: false,
    unorderedList: false,
    removeFormat: false,
    separator: true
  },
  maxHeight: '500px'
})
